// ComingSoonPage.jsx
import React from "react";

const ComingSoonPage = () => {
  return (
    <div className="absolute inset-0 bg-black/70 backdrop-blur-md z-10 flex items-center justify-center rounded-xl">
      <div className="text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-white tracking-wide animate-pulse">
          Coming Soon
        </h1>
        <p className="mt-4 text-base md:text-lg text-white/80">
          We're working hard to bring you this feature!
        </p>
        <div className="mt-6 flex justify-center">
          <div className="w-16 h-1 bg-gradient-to-r from-[#5C1FE2] to-[#834CFF] rounded-full animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
